import { render, staticRenderFns } from "./ClubDropdown.vue?vue&type=template&id=1f3a7b1c"
import script from "./ClubDropdown.vue?vue&type=script&lang=js"
export * from "./ClubDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports